import { type AnyApiGridQueryStateValue } from "@package/ui-redux";
import { produce, type WritableDraft } from "immer";
import { useCallback, useMemo, type PropsWithChildren } from "react";
import {
  defaultItemGridFilterContextState,
  ItemGridFilterContext,
  type ItemGridFilterState,
} from "./context-item-grid-filter";

type ItemGridFilterProviderProps = {
  filter?: AnyApiGridQueryStateValue["variables"]["filter"];
  onFilterChanged?: (
    filter: AnyApiGridQueryStateValue["variables"]["filter"],
  ) => void;
};

export function ItemGridFilterProvider({
  filter,
  onFilterChanged,
  children,
}: PropsWithChildren<ItemGridFilterProviderProps>) {
  const updateFilterState = useCallback(
    (
      callback: (
        draft: WritableDraft<AnyApiGridQueryStateValue["variables"]["filter"]>,
      ) => void,
    ) => {
      onFilterChanged?.(produce(filter, callback));
    },
    [filter, onFilterChanged],
  );

  const state = useMemo<ItemGridFilterState>(
    () => ({
      ...defaultItemGridFilterContextState,
      filter,
      updateFilterState,
    }),
    [filter, updateFilterState],
  );

  return (
    <ItemGridFilterContext.Provider value={state}>
      {children}
    </ItemGridFilterContext.Provider>
  );
}
